export default __webpack_public_path__ + "static/step2-406426f6c9c12f9e78d0241ba6adbbde.webp";